module.exports = __webpack_public_path__ + "img/ctrl-t-1.79bf3575.svg";